module.exports = __webpack_public_path__ + "img/10.8b5ef789.png";